import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-mdm',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './mdm.component.html',
})
export class MdmComponent {}
